import React from 'react';
import { Link } from 'react-router';
import { FaAngleRight, FaUserAlt, FaBuilding, FaUserPlus, FaGraduationCap } from "react-icons/fa";

class Select extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            snackbarOpen: false
        };

        // Paleta Profissional
        this.colors = {
            pf: '#4f46e5',
            pj: '#7c3aed',
            dep: '#64748b',
            curso: '#10b981',
            bg: '#f8fafc',
            text: '#334155'
        };
    }

    renderCard(title, path, color, IconComponent, isExternal = false) {
        // Estilos Inline para máxima compatibilidade
        const cardStyle = {
            display: 'flex',
            backgroundColor: '#ffffff',
            borderRadius: '10px',
            marginBottom: '16px',
            height: '85px',
            alignItems: 'center',
            border: '1px solid #e2e8f0',
            textDecoration: 'none',
            color: 'inherit',
            overflow: 'hidden',
            cursor: 'pointer',
            transition: 'transform 0.2s ease'
        };

        const iconContainer = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '85px',
            height: '100%',
            backgroundColor: color,
            color: '#ffffff'
        };

        const contentStyle = {
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 20px',
            fontFamily: 'sans-serif'
        };

        const labelStyle = {
            fontSize: '15px',
            fontWeight: '600',
            color: '#334155'
        };

        const content = (
            <div style={cardStyle} className="card-item-hover">
                <div style={iconContainer}>
                    <IconComponent size={24} />
                </div>
                <div style={contentStyle}>
                    <span style={labelStyle}>{title}</span>
                    <FaAngleRight color="#cbd5e1" size={18} />
                </div>
            </div>
        );

        return isExternal ? (
            <a href={path} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
                {content}
            </a>
        ) : (
            <Link to={path} style={{textDecoration: 'none'}}>
                {content}
            </Link>
        );
    }

    render() {
        const isSalesman = localStorage.getItem('dental_y') === 'SALESMAN';
        const isPJCadastro = localStorage.getItem('dental_y') === 'PJCADASTRO';
        const isCadastro = localStorage.getItem('dental_y') === 'REGISTER';
        const isFinanceiro = localStorage.getItem('dental_y') === 'FINANCEIRO';
        const isCorretora = localStorage.getItem('dental_y') === 'BROKER';

        const hasAccess = localStorage.getItem('dental_cc') === '7';

        return (
            <div style={{ padding: '40px 15px', backgroundColor: this.colors.bg, minHeight: '100vh' }}>
                <style>{`
                    .card-item-hover:hover {
                        background-color: #f1f5f9 !important;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
                    }
                `}</style>

                <div style={{ 
                    textAlign: 'center', 
                    fontSize: '22px', 
                    fontWeight: 'bold', 
                    color: '#1e293b',
                    marginBottom: '40px',
                    fontFamily: 'sans-serif'
                }}>
                    {
                        isFinanceiro ? (
                            "GESTÃO FINANCEIRA"
                        ) : (
                            "OPÇÕES DE PAINÉIS"
                        )
                    }
                   
                </div>

                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    { (isCadastro || isSalesman || isCorretora) &&  (
                        this.renderCard('PAINEL PESSOA FÍSICA', '/panel/pessoa-fisica', this.colors.pf, FaUserAlt)
                    )}
                    { (isPJCadastro || isSalesman || isCorretora) &&(
                        this.renderCard('PAINEL PESSOA JURÍDICA (PJ)', '/panel/pessoa-juridica', this.colors.pj, FaBuilding)
                    )}                    
                    { (isCadastro || isSalesman || isPJCadastro || isCorretora) && (
                        this.renderCard('INCLUSÃO DE DEPENDENTE', '/panel/painel-inclusao', this.colors.dep, FaUserPlus)
                    )} 
                    {isSalesman && hasAccess && (
                        this.renderCard(
                            'CURSO DE CAPACITAÇÃO', 
                            'https://planodentalcenter.aluno.vc/', 
                            this.colors.curso, 
                            FaGraduationCap,
                            true
                        )
                    )}
                </div>
            </div>
        );
    }
}

export default Select;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/ResumeNew/Select.js
 **/